import React, { useEffect } from "react";
import emailjs from "emailjs-com";
import { useHistory } from "react-router-dom";

import "../App.css";

const Checkout_ok = () => {
  const history = useHistory();

  const send_mail_error = () => {
    const message =
      " <html style='prefers-color-scheme:light'><body style='prefers-color-scheme:light;'><div style='background:#fff;color:rgba(0,0,0,.87);font-family:Roboto,Helvetica,Arial,sans-serif;margin:0;padding:0;color:#333'><div style='background:#fff;max-width:500px;margin:auto;'><div style='background-color:#ffffff;margin:15px;'><h1 style='font-size:30px;font-weight:800;color:#333;padding:20px 0px;text-align:left;'>Hemos recibido tu pedido </h1></div><p style='padding: 10px 20px;border-radius:15px'>Agradecemos tu compra en <b> .</b> Te lo despacharemos en un máximo de 3 días hábiles. </p><div style='margin: 50px 0px'><p style='font-size: 20px; font-weight: 600'>Tu Pedido</p><div style='border: 1px #D6D6D6 solid; padding: 20px; border-radius: 12px'>" +
      JSON.parse(localStorage.getItem("ventu_products")) +
      "</div></div><div style='margin: 50px 0px'><p style='font-size: 20px; font-weight: 600'>Tus Datos de Despacho</p><div style='border: 1px #D6D6D6 solid; padding: 20px; border-radius: 12px'><p style='margin:0; font-size: 15px; font-weight: 600; color: #444444'>" +
      JSON.parse(localStorage.getItem("ventu_user")) +
      "</p></div></div><div style='margin: 20px 0px'><p style='font-size: 20px; font-weight: 600'>Datos de Transferencia</p><div style='border: 1px #D6D6D6 solid; padding: 20px; border-radius: 12px'><p style='margin:0; font-size: 15px; font-weight: 600; color: #444444'>" +
      JSON.parse(localStorage.getItem("ventu_store")) +
      "</p></div></div><div style='margin: 60px 0px 20px 0px'><p style='text-align: center; color: #A0A0A0; letter-spacing: 1px; font-weight: 300'>Crea tu tienda online en <b>ventu.cl</b></p></div></div></div></body></html>";

    const param = {
      message: message,
      mail: "fmoore@witby.cl",
      store_name: "Error",
      store_mail: "hola@cornerdog.cl",
    };

    emailjs
      .send(
        "service_cornerdog",
        "template_cornerdog",
        param,
        "user_n4i49dY2vNAhyT85v6Aam"
      )
      .then(erase())
      .catch(() => history.push("/error"));
  };

  const enviar_email = () => {
    if (
      localStorage.getItem("ventu_products") == null ||
      localStorage.getItem("ventu_store") == null ||
      localStorage.getItem("ventu_user") == null
    ) {
      // history.push("/error");
      send_mail_error();
      return;
    }

    const ventu_products = JSON.parse(localStorage.getItem("ventu_products"));
    const ventu_store = JSON.parse(localStorage.getItem("ventu_store"));
    const ventu_user = JSON.parse(localStorage.getItem("ventu_user"));

    let html_productos = "";
    const html_direccion = ventu_user.domicilio
      ? ventu_user.direccion + ", " + ventu_user.comuna + "."
      : "";
    const html_metodo_pago = ventu_user.tarjeta
      ? "Pago con tarjeta"
      : "Pago con transferencia";

    ventu_products.map((item) => {
      if (item.n > 0) {
        html_productos =
          html_productos +
          "<div style='display: flex; justify-content: space-around; align-items: center; width: 100%'><div><p style='margin:0; font-size: 15px; font-weight: 600; color: #444444'>" +
          item.name +
          "</p><p style='margin:0; font-size: 14px; color: #878787'>" +
          item.n +
          " unidad(es)</p></div><p style='height: 100%; font-size: 15px; font-weight: 600; color: #444444; margin-left: 30px'>$" +
          Number(item.n * item.price).toLocaleString() +
          "</p></div>";
      }
      return "";
    });

    const message =
      "<html style='prefers-color-scheme:light'><body style='prefers-color-scheme:light;'><div style='background:#fff;color:rgba(0,0,0,.87);font-family:Roboto,Helvetica,Arial,sans-serif;margin:0;padding:0;color:#333'><div style='background:#fff;max-width:500px;margin:auto;'><div style='background-color:#ffffff;margin:15px;'><h1 style='font-size:30px;font-weight:800;color:#333;padding:20px 0px;text-align:left;'>Hemos recibido tu pedido </h1></div><p style='padding: 10px 20px;border-radius:15px'>Agradecemos tu compra en <b>" +
      ventu_store.name +
      ".</b> Te lo despacharemos en un máximo de 3 días hábiles.</p><div style='margin: 50px 0px'><p style='font-size: 20px; font-weight: 600'>Tu Pedido</p><div style='border: 1px #D6D6D6 solid; padding: 20px; border-radius: 12px'>" +
      html_productos +
      "</div><div style='border: 1px #D6D6D6 solid; padding: 20px; border-radius: 12px; margin: 30px 0px 0px 0px'><p style='font-size: 20px; font-weight: 800;margin: 0; color: #3F4AB1'>$ " +
      Number(ventu_user.price_total).toLocaleString() +
      " </p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'> " +
      html_metodo_pago +
      ". Pagaste por el despacho $" +
      Number(ventu_user.delivery_price).toLocaleString() +
      ". " +
      ventu_user.iva +
      "</p></div></div><div style='margin: 50px 0px'><p style='font-size: 20px; font-weight: 600'>Tus Datos de Despacho</p><div style='border: 1px #D6D6D6 solid; padding: 20px; border-radius: 12px'><p style='margin:0; font-size: 15px; font-weight: 600; color: #444444'>" +
      ventu_user.nombre +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      html_direccion +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      ventu_user.otros +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      ventu_user.celular +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      ventu_user.rut +
      "</p></div></div><div style='margin: 20px 0px'><p style='font-size: 20px; font-weight: 600'>Datos de Transferencia</p><div style='border: 1px #D6D6D6 solid; padding: 20px; border-radius: 12px'><p style='margin:0; font-size: 15px; font-weight: 600; color: #444444'>" +
      ventu_store.name +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      ventu_store.bank_bank +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      ventu_store.bank_type +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      ventu_store.bank_number +
      "</p><p style='font-size: 15px; color: #878787; margin: 5px 0px;'>" +
      ventu_store.bank_rut +
      "</p></div></div><div style='margin: 60px 0px 20px 0px'><p style='text-align: center; color: #A0A0A0; letter-spacing: 1px; font-weight: 300'>Crea tu tienda online en <b>ventu.cl</b></p></div></div></div></body></html>";

    const param = {
      message: message,
      mail: ventu_user.mail,
      store_name: ventu_store.name,
      store_mail: ventu_store.mail,
    };

    emailjs
      .send(
        "service_cornerdog",
        "template_cornerdog",
        param,
        "user_n4i49dY2vNAhyT85v6Aam"
      )
      .then(() => erase())
      .catch(() => history.push("/error"));
  };

  const erase = () => {
    localStorage.removeItem("ventu_products");
    localStorage.removeItem("ventu_store");
    localStorage.removeItem("ventu_user");
  };

  useEffect(() => {
    enviar_email();
  }, []);

  return (
    <div className="checkout_ok">
      <img src="./img/ok.gif" alt=""></img>
      <h1>¡Todo Listo!</h1>
      <p>
        <b>El envío lo hacemos en 3 días hábiles. Si tienes dudas o quieres cancelar tu pedido,</b> puedes responder el
        mail que te enviamos, escribirnos por Whatsapp{" "}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://api.whatsapp.com/send/?phone=56966564743&text&app_absent=0"
        >
          aquí
        </a>{" "}
        o por Direct{" "}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.instagram.com/corner__dog/"
        >
          aquí
        </a>
        .
      </p>
      <p>Datos de transferencia:</p>
      <div className="transferencias_ok">
        <p>Cornerdog</p>
        <p>18.396.969-2</p>
        <p>Banco Estado | Cta Rut/Vista</p>
        <p>N° 18396969</p>
        <p>hola@cornerdog.cl</p>
      </div>
      <img src="./img/logo_footer2.png" alt="" style={{ height: "60px" }}></img>
    </div>
  );
};

export default Checkout_ok;
